import {Box} from "./box";

export class Encoder {
	public encodeBack(box: Box): string {
		const color = box.getColor();

		const back = box.hasBack() ? color : '0';

		return back;
	}

	public decodeBack(encoded: string, box: Box) {
		if (encoded === 'n' || encoded === 'w') {
			box.addBack();
		}
	}

	public encodeDoor(box: Box) {
		const color = box.getColor();

		const door = box.hasDoor() ? color : '0';

		return door;
	}

	public decodeDoor(encoded: string, box: Box){
		if (encoded === 'n' || encoded === 'w') {
			box.addDoor();
		}
	}

	public encodeShelf(box: Box) {
		const color = box.getColor();

		const shelfCount = box.getShelfCount();

		var encoded;
		if (shelfCount == 0) {
			encoded = '0000';
		} else if (shelfCount == 1) {
			encoded = `${color}000`;
		} else if (shelfCount == 2) {
			encoded = `${color}${color}00`;
		} else if (shelfCount == 3) {
			encoded = `${color}${color}${color}0`;
		} else if (shelfCount == 4) {
			encoded = `${color}${color}${color}${color}`;
		}

		return encoded;
	}

	public encodeNoShelf() {
		return '0000';
	}

	public decodeShelf(encoded: string, box: Box){
		let shelfCount = 0;

		switch (encoded) {
			case 'n000':
			case 'w000':
			case '0n00':
			case '0w00':
				shelfCount = 1;
				break;
			case 'nn00':
			case 'ww00':
				shelfCount = 2;
				break;
			case 'nnn0':
			case 'www0':
				shelfCount = 3;
				break;
			case 'nnnn':
			case 'wwww':
				shelfCount = 4;
				break;
		}

		box.setShelves(shelfCount);
	}

	public encodeDrawers(box: Box) {
		const color = box.getColor();
		let encoded = '';

		switch (true) {
			case box.isCubeSizeSmall():
			case box.isCubeSizeWide():
				encoded =
					(box.hasDrawerBottom() ? `${color}` : '0') +
					(box.hasDrawerTop() ? `${color}0` : '00');
				break;
			case box.isCubeSizeLarge():
			case box.isCubeSizeTall():
				encoded =
					(box.hasDrawerBottom() ? `${color}` : '0') +
					(box.hasDrawerMiddle() ? `${color}` : '0') +
					(box.hasDrawerTop() ? `${color}` : '0');
				break;
			case box.isCubeSizeSmallCorner():
				encoded = `${color}-corner-right`;
				break;
		}

		return encoded;
	}

	public encodeNoDrawers() {
		return '000';
	}

	public decodeDrawers(encoded: string, box: Box) {
		if (encoded[0] === 'n' || encoded[0] === 'w') {
			box.addDrawerBottom();
		}

		if (encoded[1] === 'n' || encoded[1] === 'w') {
			box.addDrawerMiddle();
		}

		if (encoded[2] === 'n' || encoded[2] === 'w') {
			box.addDrawerTop();
		}
	}

	public encodeCornerDirection(box: Box) {
		const corner = box.isDirectionRight() ? 'r' : 'l';

		return corner;
	}

	public decodeCornerDirection(encoded: string, box: Box) {
		if (encoded === 'r') {
			box.setDirectionRight();
		} else {
			box.setDirectionLeft();
		}
	}

	public encodeCrossDivider(box: Box) {
		const color = box.getColor();

		if (box.hasCrossDivider()) {
			return color;
		} else {
			return '0';
		}
	}

	public decodeCrossDivider(encoded: string, box: Box) {
		if (encoded === 'n' || encoded === 'w') {
			box.addCrossDivider();
		}
	}

	public encodeImageName(box: Box) {
		let imageName;
		if (box.isCorner()) {
			imageName = `${box.getSize()}_${box.getColor()}-${box.getDirection()}`;
		} else {
			const size = box.getSize();
			const color = box.getColor();
			const back = this.encodeBack(box);

			if (box.hasCrossDivider()) {
				imageName = `${size}_${color}-${back}`;
			} else {
				const door = this.encodeDoor(box);

				const shelf = box.hasDoor()
					? this.encodeNoShelf()
					: this.encodeShelf(box);
				const drawers = box.hasDoor()
					? this.encodeNoDrawers()
					: this.encodeDrawers(box);

				imageName = box.getSize() + '_' + box.getColor() + '-back-' + back + '-door-' + door + '-drawer-' + drawers + '-shelf-' + shelf;
			}
		}

		return imageName;
	}
}
